import { useState } from "react";
import Gallery from "./Gallery";
import Videos from "./Videos/Videos";

import "./Services.css";
import myApp from "./icons/images/app.svg";
import myDm from "./icons/images/dm.svg";
import mySeo from "./icons/images/seo.svg";
import myWeb from "./icons/images/web.svg";
import { Button } from "@mui/material";

function Services() {
  const [show, setShow] = useState(false);
  const [showvid, setShowvid] = useState(false);
  return (
    <>
      <div className="container-fluid" id="section-two">
        <h1 className="text-center  display-3 fw-bold">
          <span className="uno-theme-text">Our</span>{" "}
          <span className="theme-text">Services</span>
        </h1>
        <hr className="mx-auto mb-5 w-25" />
        <div className="row mb-5">
          <div className="col-12 col-sm-6 col-md-3 m-auto mb-3">
            {/* <!-- card starts here --> */}
            <div className="card shadow" id="card">
              <img src={myApp} alt="Logo" className="card-img-top" />

              <div className="card-body">
                <h3 className="text-center">2D ANIMATION</h3>
                <hr
                  className="mx-auto w-75"
                  style={{ marginBottom: "-0.5rem" }}
                />
                <p>
                  We excel in crafting captivating stories through traditional
                  animation.
                </p>
                <Button
                  variant="outlined"
                  href="#photos"
                  onClick={() => {
                    setShow(!show);
                  }}
                >
                  {" "}
                  Click Here to view Portfolio
                </Button>
              </div>
            </div>
            {/* <!-- card ends here --> */}
          </div>
          {/* <!-- col ends here --> */}
          <div className="col-12 col-sm-6 col-md-3 m-auto mb-3">
            {/* <!-- card starts here --> */}
            <div className="card shadow" id="card">
              <img src={myDm} alt="Logo" className="card-img-top" />
              <div className="card-body">
                <h3 className="text-center">Graphic Design</h3>
                <hr
                  className="mx-auto w-75"
                  style={{ marginBottom: "-0.5rem" }}
                />
                <p>
                 We love to design. What makes us unique is our passionate creativity
                </p>
                <Button
                  variant="outlined"
                  href="#videos"
                  onClick={() => {
                    setShowvid(!showvid);
                    setShow(false);
                  }}
                >
                  {" "}
                  Click Here to view Portfolio
                </Button>
              </div>
            </div>
            {/* <!-- card ends here --> */}
          </div>
          {/* <!-- col ends here --> */}
          <div className="col-12 col-sm-6 col-md-3 m-auto mb-3">
            {/* <!-- card starts here --> */}
            <div className="card shadow" id="card">
              <img src={myWeb} alt="Logo" className="card-img-top" />
              <div className="card-body">
                <h3 className="text-center">Digital Marketing / Adverts</h3>
                <hr
                  className="mx-auto w-75"
                  style={{ marginBottom: "-0.5rem" }}
                />
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
                </p>
                <Button variant="outlined" href="#outlined-buttons">
                  {" "}
                  Click Here to view Portfolio
                </Button>
              </div>
            </div>
            {/* <!-- card ends here --> */}
          </div>
          {/* <!-- col ends here --> */}
          <div className="col-12 col-sm-6 col-md-3 m-auto mb-3">
            {/* <!-- card starts here --> */}
            <div className="card shadow" id="card">
              <img src={mySeo} alt="Logo" className="card-img-top" />
              <div className="card-body">
                <h3 className="text-center">Graphic Design</h3>
                <hr
                  className="mx-auto w-75"
                  style={{ marginBottom: "-0.5rem" }}
                />
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
                </p>
                <Button variant="outlined" href="#outlined-buttons">
                  {" "}
                  Click Here to view Portfolio
                </Button>
              </div>
            </div>
            {/* <!-- card ends here --> */}
          </div>
          {/* <!-- col ends here --> */}
        </div>
      </div>
      <div id="photos">
        {" "}
        {show && <Gallery />}
        {showvid && <Videos />}
      </div>
    </>
  );
}

export default Services;
